import { gql } from "graphql-request";

const SERVER_REOPEN_SURVEY = gql`
  mutation SERVER_ReopenSurvey($userSurveyId: ID!) {
    reopenSurvey(userSurveyId: $userSurveyId)
  }
`;
export default SERVER_REOPEN_SURVEY;